// extracted by mini-css-extract-plugin
export var iconWrapper = "blogPostSocialShare-module--iconWrapper--QTZx2";
export var sbShowMain = "blogPostSocialShare-module--sb-show-main--vizL7";
export var wrapper = "blogPostSocialShare-module--wrapper--VYKi6";